import React, { useState, useEffect , useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import {useReactToPrint} from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function EmployeeMaster(props) {
  const [rooms, setRooms] = useState([]);
  
  const [EmpCode, setEmpCode] = useState('');
  const [EmpName, setEmpName] = useState('');
  const [City, setCity] = useState('');
  const [MobileNo, setMobileNo] = useState('');

  const [EmployeeMasterEntries, setEmployeeMasterEntries] = useState([]);

  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [flag, setFlag] = useState('');
  const [formMode, setFormMode] = useState('add');
  const [editRoomId, setEditRoomId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);

  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);  

  useEffect(() => {
    fetchEmpMaster();
  }, []);


  const fetchEmpMaster = async () =>{
    try{
      const response = await axios.get('https://www.wingap.net.in/api/employee');
      setEmployeeMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1;
      setEmpCode(nextEntryNo)
      //console.log(response)
    }catch(error){
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.EmpCode > maxEntryNo) {
        maxEntryNo = entry.EmpCode;
      }
    }
    return maxEntryNo;
  };



  const addEmployee = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/employee', {
        EmpCode: EmpCode,
        EmpName: EmpName,
        City: City,
        MobileNo: MobileNo,
        UserID: props.name
      });
      fetchEmpMaster();
      setEmpCode('');
      setEmpName('');
      setCity('');
      setMobileNo('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateRoom = async (EmpCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/employee/${EmpCode}`, {
        EmpCode: EmpCode,
        EmpName: EmpName,
        City: City,
        MobileNo: MobileNo,
        UserID: props.name
      });
      fetchEmpMaster();
      setEmpCode('');
      setEmpName('');
      setCity('');
      setMobileNo('');
      setFormMode('add');
    
    } catch (error) {
      console.log('Error:', error);
    }
  };
  
  

  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteRoom(deleteEntryNo.EmpCode);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteRoom = async (EmpCode) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/employee/${EmpCode}`, {
        headers: {
          'username': props.name,
        },
      });

      if (response.status === 200) {
        await fetchEmpMaster();
      }
    } catch (error) {
      console.log('Error:', error);
    
      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };

  const setEditForm = (room) => {
      setFormMode('edit');
      setEmpCode(room.EmpCode);
      setEmpName(room.EmpName);
      setCity(room.City);
      setMobileNo(room.MobileNo);
      setShowGrid(false);
  };

  
  /* const handleSearch = (searchQuery) => {
    const filtered = rooms.filter((room) => {
      // Convert room.RoomNo, room.deptName, etc., to strings before using includes
      const deptCode = room.DeptCode.toString().toLowerCase();
      const deptName = room.deptName.toString().toLowerCase();
      const deptNameENG = room.deptNameENG.toString().toLowerCase();
      const compCode = room.compCode.toString().toLowerCase();
      const flag = room.flag.toString().toLowerCase();

      // Check if any of the properties contain the searchQuery (converted to lowercase)
      return (
        deptCode.includes(searchQuery.toLowerCase()) ||
        deptName.includes(searchQuery.toLowerCase()) ||
        deptNameENG.includes(searchQuery.toLowerCase()) ||
        compCode.includes(searchQuery.toLowerCase()) ||
        flag.includes(searchQuery.toLowerCase())
      );
    }); 

    // Update the deptMasterEntries state with the filtered results
    setDeptMasterEntries(filtered);
  };*/

  // ... Rest of your code ...

  // Update the filtered rooms based on the searchQuery prop
  /* useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, rooms]);
 */
  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setRooms(rooms); 
  }

  const handleCancel = () => {
    setFormMode('add');
    setEditRoomId('');
    setEmpCode('');
    setEmpName('');
    setCity('');
    setMobileNo('');
    fetchEmpMaster();
}

   
  const componentPDF= useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "CompanyData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto',padding: '20px' }} >
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Employee Master</h1>
      <Grid item>
          <Button
            variant="contained"
            className="view-button"
            onClick={handleshowandhide}
            sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float:'right'}}
          >
            {showGrid ? 'Add' : 'Back'}
          </Button>
        </Grid>
        {showGrid && <Grid item>
          <Button
            variant="contained"
            onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float:'right', marginRight:"10px"}}
          >
            Download PDF
          </Button>
        </Grid>}
        {showGrid && <Grid item>
          <Button
            variant="contained"
            // onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float:'right', marginRight:"10px"}}
          >
            Export
          </Button>
        </Grid>}
        {!showGrid && (
           <>
           <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
           <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="EmpCode" style={{ width: '150px', marginRight: '10px' }}>EmpCode</label>
               <input
                 type="text"
                 value={EmpCode}
                 readOnly
                 placeholder="EmpCode"
                 style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="EmpName" style={{ width: '150px', marginRight: '10px' }}>EmpName</label>
               <input
                 type="text"
                 value={EmpName}
                 onChange={(e) => setEmpName(e.target.value)}
                 placeholder="EmpName"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="City" style={{ width: '150px', marginRight: '10px' }}>City</label>
               <input
                 type="text"
                 value={City}
                 onChange={(e) => setCity(e.target.value)}
                 placeholder="City"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="MobileNo" style={{ width: '150px', marginRight: '10px' }}>MobileNo</label>
               <input
                 type="text"
                 value={MobileNo}
                 onChange={(e) => setMobileNo(e.target.value)}
                 placeholder="MobileNo"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             </div>
           <div>
             <button
               className={formMode === 'add' ? 'add-button' : 'update-button'}
               onClick={formMode === 'add' ? addEmployee : () => updateRoom(EmpCode)}
               style={{
                 padding: '10px 20px',
                 fontSize: '16px',
                 backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                 color: 'white',
                 border: 'none',
                 cursor: 'pointer',
                 marginBottom: '10px',
               }}
             >
               {formMode === 'add' ? 'Add' : 'Update'}
             </button>
             <button
               className="view-button"
               onClick={handleCancel}
               style={{
                 padding: '10px 20px',
                 fontSize: '16px',
                 backgroundColor: '#f44336',
                 color: 'white',
                 border: 'none',
                 cursor: 'pointer',
                 marginLeft: '10px',
                 marginBottom: '10px',
               }}
             >
               Cancel
             </button>
           </div>
         </>
         
          )}
        {showGrid && (
            <div ref={componentPDF} style={{width:'100%'}}>
              <h2>Entries</h2>
              <table
                style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  border: '1px solid #ccc',
                }}
              >
                <thead>
                  <tr style={{ background: '#f2f2f2', color:'black' }}>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      EmpCode
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      EmpName
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      City
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      MobileNo
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {EmployeeMasterEntries.map((room) => (
                    <tr key={room.EmpCode} style={{backgroundColor:'white', color:'black', textAlign:'center'}}>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.EmpCode}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.EmpName}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.City}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.MobileNo}</td>
                      <td className="print-hide" >
                        <button
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'rgb(76, 175, 80)',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            marginRight: '5px',
                            marginLeft:'10px',
                          }}
                          onClick={() => setEditForm(room)}
                        >
                          Edit
                        </button>
                        <button
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'rgb(244, 67, 54)',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setDeleteEntryNo({EmpCode: room.EmpCode});
                            setOpenConfirmation(true); 
                          }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{ fontSize: '16px' }} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>
 

<Dialog
            open={openConfirmation}
            onClose={() => setOpenConfirmation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to DELETE ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                Cancel
              </Button>
              <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                DELETE
              </Button>
            </DialogActions>
          </Dialog>
    </div>
  );
}

export default EmployeeMaster;